var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:{
        'avatar__sm': _vm.size === 'sm',
        'avatar__lg': _vm.size === 'lg',
    }},[_c('img',{staticClass:"avatar__img",attrs:{"src":_vm.src,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }